
export default function IndustriesSection() {
  const industries = [
    {
      icon: 'ri-shopping-cart-line',
      name: 'E-commerce',
      description: 'Online retail stores and marketplaces'
    },
    {
      icon: 'ri-home-line',
      name: 'Real Estate',
      description: 'Builders, developers, and brokers'
    },
    {
      icon: 'ri-book-line',
      name: 'Education',
      description: 'Schools, institutes, and online courses'
    },
    {
      icon: 'ri-hotel-line',
      name: 'Hospitality',
      description: 'Hotels, restaurants, and travel'
    },
    {
      icon: 'ri-heart-pulse-line',
      name: 'Fitness',
      description: 'Gyms, trainers, and wellness centers'
    },
    {
      icon: 'ri-shirt-line',
      name: 'Fashion',
      description: 'Clothing and jewelry brands'
    },
    {
      icon: 'ri-leaf-line',
      name: 'Organic Brands',
      description: 'Natural and sustainable products'
    },
    {
      icon: 'ri-tools-line',
      name: 'Household',
      description: 'Home essentials and utility brands'
    },
    {
      icon: 'ri-makeup-line',
      name: 'Cosmetics And Wellcare Products',
      description: 'Beauty, skincare, and wellness products'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Industries We Work With
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We have extensive experience across diverse industries, delivering tailored marketing solutions that drive results for businesses of all sizes.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {industries.map((industry, index) => (
            <div key={index} className="text-center p-6 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${industry.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {industry.name}
              </h3>
              <p className="text-sm text-gray-600">
                {industry.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
